





















































































































import {Component} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import QuantityLimitsFilter from '@/components/Settings/QuantityLimits/QuantityLimitsFilter.vue'
import {ScrollButton} from "wings-ui-components";
import {QuantityLimitItem} from '@/store/settings/quantity_limits/types';
import BaseItemsPage from '../BaseItemsPage';
import {secondsToTime} from "@/utils/date-util";

@Component({components: {QuantityLimitsFilter, ScrollButton}})
export default class QuantityLimits extends BaseItemsPage<QuantityLimitItem> {

  @Getter('quantityLimits') quantityLimitResponse!: QuantityLimitItem[];

  is_show_filter = false;
  currentSort = 'id';
  currentSortOrder = 'desc';
  tableFields = ['transport_names', 'template_names', 'message_type_names', 'message_limit', 'timeout'];

  getData(): QuantityLimitItem[] {
    return this.quantityLimitResponse;
  }

  getJoinedArray(item: string[] | undefined | null): string | undefined | null {
    return item?.join(', ');
  }

  getTimeFromSeconds(seconds: number): string | null {
    return seconds ? secondsToTime(seconds) : null;
  }
}
